import { render, staticRenderFns } from "./ShowClient.vue?vue&type=template&id=24870a7f&scoped=true"
import script from "./ShowClient.vue?vue&type=script&lang=js"
export * from "./ShowClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24870a7f",
  null
  
)

export default component.exports